export default __webpack_public_path__ + "static/media/buyerPrequal.4524e400.svg";